import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import AppStoreButtons from '../shared/AppStoreButtons';
import '../../styles/landing/AppDownloadSection.css';

const AppDownloadSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section
            id="download"
            className="landing-section landing-section--cream app-download-section"
            aria-labelledby="download-heading"
        >
            <div className="landing-container app-download-section__inner">
                <SectionHeader
                    title={t('appDownload.title')}
                    subtitle={t('appDownload.subtitle')}
                    id="download-heading"
                />
                <AppStoreButtons />
            </div>
        </section>
    );
};

export default AppDownloadSection;
